var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-0",attrs:{"id":"app"}},[(_vm.$store.state.auth.loggedIn)?_c('SiteMenu'):_vm._e(),_c('router-view'),_c('EditOrderModals')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }